import { atom } from 'recoil';

export const webServicesSearchFilterState = atom<string | undefined>({
  key: 'app.webServices.search.filter',
  default: undefined,
});
